import { Injectable } from '@angular/core';
import { ConfirmModalComponent } from '../components/confirm-modal/confirm-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class ConfirmModalService {

  constructor(private modalService: NgbModal) { }

  confirm(title: string, message: string, windowCustomClass: any = null, confirmationButtonText: string = 'Confirm', isAlert: boolean = false): Promise<boolean> {
    const modalRef = this.modalService.open(ConfirmModalComponent, {
      centered: true,
      windowClass: windowCustomClass,
    });
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.message = message;
    modalRef.componentInstance.confirmationButtonText = confirmationButtonText;
    modalRef.componentInstance.isAlert = isAlert;
    return modalRef.result;
  }
}
